<template>
    <div class="grid-item grid-item-full">
        <div class="grid-content">
            <div :class="styles">
                <r-input
                    label="First Name"
                    v-model="contact.firstName"
                    @input="updateContact"
                />
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="Last Name"
                    v-model="contact.lastName"
                    @input="updateContact"
                />
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="Organization"
                    v-model="contact.organization"
                    @input="updateContact"
                />
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="Address Line 1"
                    help-text="Street address, P.O. box, company name, c/o"
                    v-model="contact.address"
                    @input="updateContact"
                />
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="Address Line 2"
                    help-text="Apartment, suite, unit, building, floor, etc"
                    v-model="contact.address2"
                    @input="updateContact"
                />
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="City"
                    v-model="contact.city"
                    @input="updateContact"
                />
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <v-select
                    label="Country"
                    :options="countryList"
                    v-model="contact.country"
                    @input="clearRegion"
                />
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <v-select
                    v-if="hasRegion"
                    label="Region (state or province)"
                    :options="regionNames"
                    option-label="regionName"
                    option-key="regionCode"
                    v-model="contact.region"
                    @input="updateContact"
                />
                <r-input
                    v-else
                    label="Region (state or province)"
                    v-model="contact.region"
                    @input="updateContact"
                />
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <r-input
                    label="Postal/Zip Code"
                    v-model="contact.postalCode"
                    @input="updateContact"
                />
            </div>
            <div class="grid-item grid-item-full">
                <contact-phones-emails
                    ref="phoneNumbersAndEmails"
                    :aggregator="validationAggregator"
                    v-model="contact"
                    @input="updateContact"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        vRadio, vSelect,
    } from '@/components/form';
    import {COUNTRIES_LIST} from '@/data/countries';
    import REGIONS from '@/data/regions';
    import ContactModel from '@/common/models/contact-model';
    import ContactPhonesEmails from '@/components/contact-manager/contact-phones-emails';

    export default {
        name: 'contact-form',
        components: {
            vRadio,
            vSelect,
            ContactModel,
            ContactPhonesEmails,
        },
        props: {
            value: {
                type: Object,
                required: true,
            },
            validationAggregator: {
                type: Object,
            },
            fluid: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                contact: new ContactModel(this.value.cloneSelf()),
                countryList: COUNTRIES_LIST,
                regionList: {...REGIONS},
            };
        },
        computed: {
            styles() {
                const style = {};
                if (this.fluid) {
                    style['grid-item grid-item-full'] = true;
                } else {
                    style['grid-item grid-item-half grid-item-break-half'] = true;
                }
                return style;
            },
            regionNames() {
                return this.regionList[this.value.country];
            },
            hasRegion() {
                return ['CA', 'US'].includes(this.value.country);
            },
        },
        methods: {
            clearRegion() {
                this.contact.region = null;
                this.updateContact();
            },
            updateContact() {
                this.$emit('input', this.contact);
            },
        },
    };
</script>
